import React from 'react';
import BaseComponent from '../../../baseClasses/BaseComponent';
import './RadioButton.scss';

class RadioButton extends BaseComponent {
  //todo: create list component rather than just having the radio button

  handleOnClick(e){
    const { handleOnChange } = this.props;
    if (handleOnChange) {
      handleOnChange(!this.props.checked);
    }
  }

  render() {
    let { 
      id,
      name,
      checked,
    } = this.props;
    return (
      <div>
        <input className="radio-button" onClick={this.handleOnClick} type="radio" id={id} name={name} checked={checked} />
        <label htmlFor={id}></label>
      </div>
    );
  }
}

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/Buttons/RadioButton/index.js